import { render, staticRenderFns } from "./AwsSearchView.vue?vue&type=template&id=1b1b36ea&scoped=true"
import script from "./AwsSearchView.vue?vue&type=script&lang=js"
export * from "./AwsSearchView.vue?vue&type=script&lang=js"
import style0 from "./AwsSearchView.vue?vue&type=style&index=0&id=1b1b36ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b36ea",
  null
  
)

export default component.exports